export class UnauthorizedError extends Error {
  __proto__: Error;
  constructor() {
    const proto = new.target.prototype;
    super();
    this.__proto__ = proto;
  }
}
